export default "__VITE_ASSET__CNn$Wv85__"